import { Col, Row } from "react-bootstrap";
import { Field, useFormState } from "react-final-form";
import { useTranslation } from "react-i18next";
import BMXTextField from "../../../../../../Components/Inputs/BMXTextField/BMXTextField";
const ServiceReckoningFormStepOne = (props) => {
  const { t } = useTranslation();

  const { initialValues } = props;

  const prices = initialValues?.device?.printerModel?.servicePrice;

  const totalServiceCost = [
    ["inspectionTimeCounter", "surveyPrice"],
    ["repairTimeCounter", "repairPrice"],
    ["implementationTimeCounter", "installationPrice"],
    ["diagnosticsTimeCounter", "diagnosticsPrice"],
    ["itServiceTimeCounter", "itServicePrice"],
  ].reduce(
    (sum, [timeKey, priceKey]) =>
      sum + (initialValues?.[timeKey] ?? 0) * (prices?.[priceKey] ?? 0),
    0
  );

  const usedParts = initialValues?.parts?.filter((part) => part.used);
  const partsTotalCost = usedParts?.reduce(
    (sum, part) => sum + (Number(part.price) || 0),
    0
  );

  // KOSZT TRANSPORU DO ZAIMPLEMENTOWANIU PÓŹNIEJ
  // const transportCost = 240;
  const transportCost =
    initialValues?.requiredQuotation
      ? (initialValues?.transportCostTransportService ?? initialValues?.transportCost)
      : initialValues?.transportCostTransportService;

  const { values } = useFormState();

  const serviceDiscount = Number(values?.serviceDiscount) || 0;
  const serviceSupplement = values?.serviceSupplement || false;

  const partsDiscount = Number(values?.partsDiscount) || 0;
  const partsSupplement = values?.partsSupplement || false;

  const transportDiscount = Number(values?.transportDiscount) || 0;
  const transportSupplement = values?.transportSupplement || false;

  const applyDiscountOrSupplement = (value, discountPercent, isSupplement) => {
    if (isSupplement) {
      return value * (1 + discountPercent / 100);
    } else {
      return value * (1 - discountPercent / 100);
    }
  };

  const finalServiceValue = applyDiscountOrSupplement(
    totalServiceCost,
    serviceDiscount,
    serviceSupplement
  );

  const finalPartsValue = applyDiscountOrSupplement(
    partsTotalCost,
    partsDiscount,
    partsSupplement
  );

  const finalTransportValue = applyDiscountOrSupplement(
    transportCost,
    transportDiscount,
    transportSupplement
  );


  const totalInterventionCost =
    finalServiceValue + finalPartsValue + finalTransportValue;


  const SummaryBox = ({ title = "Usługi", netto = 0, brutto = 0, bold }) => {
    return (
      <Row>
        <Col xs={12} className="d-flex flex-column justify-content-center">
          <Row style={{ background: "#eeeec6" }} className="p-2 align-items-center">
            <Col xs={12} className="text-center mb-3">
              <div style={{ fontSize: "12px" }} className="text-muted small fw-bold">
                {title}
              </div>
            </Col>

            <Col xs={6}>
              <div className="text-muted small" >{t("global:servicereckoning.netto")}</div>
              <div className={`${bold ? "fw-bold" : ""} text-muted`} >{netto}</div>
              <hr className="mt-0" />
            </Col>

            <Col xs={6}>
              <div className="text-muted small">{t("global:servicereckoning.brutto")}</div>
              <div className={`${bold ? "fw-bold" : ""} text-muted`} >{brutto}</div>
              <hr className="mt-0" />
            </Col>
          </Row>
        </Col>
      </Row>
    );
  };
  return (
    <div style={{ justifyContent: "flex-start" }}>
      <Row>
        <Col xs={12}>
          <Field
            name="reckoningInternalSettlement"
            data-cy="reckoningInternalSettlement"
            component={BMXTextField}
            label={t("global:servicereckoning.reckoningInternalSettlement")}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Field
            name="reckoningExternalSettlement"
            data-cy="reckoningExternalSettlement"
            component={BMXTextField}
            label={t("global:servicereckoning.reckoningExternalSettlement")}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Field
            name="reckoningComments"
            data-cy="reckoningComments"
            component={BMXTextField}
            label={t("global:servicereckoning.reckoningComments")}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={2} className="d-flex flex-column justify-content-center mb-4">
          <SummaryBox
            title={t("global:servicereckoning.service")}
            netto={totalServiceCost.toFixed(2)}
            brutto={(totalServiceCost * 1.23).toFixed(2)}
          />
        </Col>
        <Col xs={2} style={{ marginTop: "45px" }}>
          <Field
            name="serviceDiscount"
            data-cy="serviceDiscount"
            component={BMXTextField}
            label={t("global:servicereckoning.serviceDiscount")}
            min={0}
            max={100}
            parse={(value) => {
              const num = Number(value);
              if (isNaN(num) || num < 0 || num > 100) return 0;
              return num;
            }}
          />
        </Col>
        <Col xs={2} style={{ marginTop: "45px" }}>
          <Field
            name="serviceSupplement"
            data-cy="serviceSupplement"
            type="checkbox"
            fieldtype={"checkbox"}
            component={BMXTextField}
            label={t("global:servicereckoning.serviceSupplement")}
          />
        </Col>
        <Col xs={2} className="d-flex flex-column justify-content-center mb-4">
          <SummaryBox
            title={t("global:servicereckoning.serviceAfterDiscount")}
            netto={finalServiceValue.toFixed(2)}
            brutto={(finalServiceValue * 1.23).toFixed(2)}
          />
        </Col>

      </Row>
      <Row>
        <Col xs={2} className="d-flex flex-column justify-content-center  mb-4">
          <SummaryBox
            title={t("global:servicereckoning.parts")}
            netto={partsTotalCost.toFixed(2)}
            brutto={(partsTotalCost * 1.23).toFixed(2)}
          />
        </Col>
        <Col xs={2} style={{ marginTop: "45px" }}>
          <Field
            name="partsDiscount"
            data-cy="partsDiscount"
            component={BMXTextField}
            label={t("global:servicereckoning.partsDiscount")}
            min={0}
            max={100}
            parse={(value) => {
              const num = Number(value);
              if (isNaN(num) || num < 0 || num > 100) return 0;
              return num;
            }}
          />
        </Col>
        <Col xs={2} style={{ marginTop: "45px" }}>
          <Field
            name="partsSupplement"
            data-cy="partsSupplement"
            type="checkbox"
            fieldtype={"checkbox"}
            component={BMXTextField}
            label={t("global:servicereckoning.partsSupplement")}
          />
        </Col>
        <Col xs={2} >
          <SummaryBox
            title={t("global:servicereckoning.partsAfterDiscount")}
            netto={finalPartsValue.toFixed(2)}
            brutto={(finalPartsValue * 1.23).toFixed(2)}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={2} >
          <SummaryBox
            title={t("global:servicereckoning.transport")}
            netto={Number(transportCost ? transportCost : 0).toFixed(2)}
            brutto={Number((transportCost ? transportCost * 1.23 : 0)).toFixed(2)}
          />
        </Col>
        <Col xs={2} style={{ marginTop: "45px" }}>
          <Field
            name="transportDiscount"
            data-cy="transportDiscount"
            component={BMXTextField}
            label={t("global:servicereckoning.transportDiscount")}
            min={0}
            max={100}
            parse={(value) => {
              const num = Number(value);
              if (isNaN(num) || num < 0 || num > 100) return 0;
              return num;
            }}
          />
        </Col>
        <Col xs={2} style={{ marginTop: "45px" }}>
          <Field
            name="transportSupplement"
            data-cy="transportSupplement"
            type="checkbox"
            fieldtype={"checkbox"}
            component={BMXTextField}
            label={t("global:servicereckoning.transportSupplement")}
          />
        </Col>
        <Col xs={2} >
          <SummaryBox
            title={t("global:servicereckoning.transportAfterDiscount")}
            netto={finalTransportValue.toFixed(2)}
            brutto={(finalTransportValue * 1.23).toFixed(2)}
          />
        </Col>
        <Col xs={{ span: 3, offset: 1 }}>
          <SummaryBox
            title={t("global:servicereckoning.summaryInterventionCost")}
            bold={true}
            netto={totalInterventionCost.toFixed(2)}
            brutto={(totalInterventionCost * 1.23).toFixed(2)}
          />
        </Col>
      </Row>

    </div >
  );
};

export default ServiceReckoningFormStepOne;
